"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLOSED = exports.OPEN = void 0;
var OPEN = 'OPEN';
exports.OPEN = OPEN;
var CLOSED = 'CLOSED';
exports.CLOSED = CLOSED;